import { InstitutionalPage } from '@/components/institutional-page'

export function TermsPage() {
  return InstitutionalPage({
    title: 'Terms of Service - ResumeHeaders',
    heading: 'Terms of Service',
    markdownUrl: '/content/terms.md',
    background: 'white',
    showHeader: true,
    showFooter: true,
  })
}
